import type LigneMouvement from '@mairistem/comptabilite/lib/ts/interfaces/piecesComptable/ligneMouvement';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const getLignesMouvements = (params: URLSearchParams) => {
  const url = '/api/finances/comptabilite/piecescomptables/lignesmouvement?';
  return request.get<unknown, TemplateRequestGet<LigneMouvement>>(`${url}${params.toString()}`);
};

export default getLignesMouvements;
